/**
 * Image de fond thème football pour les bannières / couvertures de page.
 * Stade / terrain - Unsplash (usage libre).
 */
export const COVER_BG_IMAGE = 'https://images.unsplash.com/photo-1574629810360-7efbbe195018?w=1920&q=80';

/** Overlay dégradé bleu léger pour garder le texte lisible tout en laissant bien voir l'image */
export const COVER_OVERLAY = 'linear-gradient(135deg, rgba(26, 54, 93, 0.5) 0%, rgba(44, 82, 130, 0.45) 50%, rgba(30, 70, 50, 0.2) 100%)';
